import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const Instructions = ({ handleClose }) => {
  const { t } = useTranslation();
  return (
    <Box sx={style}>
      <Typography
        id="instructions-modal-title"
        variant="h6"
        component="h2"
        gutterBottom
      >
        {t("how_to_use")}
      </Typography>
      <Typography
        id="instructions-modal-description"
        sx={{ mt: 2, whiteSpace: "pre-line" }}
      >
        {t("instructions_text")}
      </Typography>
      <Box sx={{ textAlign: "right", mt: 3 }}>
        <Button
          variant="contained"
          onClick={() => {
            handleClose(false);
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default Instructions;
